export enum TYPES_OF_RISKS {
  TYPE_ROOT_CAUSE = '0',
  TYPE_ERA = '1',
  TYPE_CLOUD_SECURITY = '2',
}

export enum TYPE_OF_ERA_RISKS {
  ERA_RISK_TYPE_MISCONFIGURATION = 1,
  ERA_RISK_TYPE_HBR = 2,
  ERA_RISK_TYPE_APP_VULNERABILITIES = 3,
  ERA_RISK_TYPE_OS_VULNERABILITIES = 4,
}

export interface RiskIncidentSidePanelWebComponentSchema {
  // all the data needed for rendering
  data: RisksData;
  risksType: string;
  sectionFocused?: string;
}

export interface RisksData {
  [TYPES_OF_RISKS.TYPE_ERA]: EntityData;
  [TYPES_OF_RISKS.TYPE_CLOUD_SECURITY]: EntityData;
}

export const ROOT_CAUSE_RISKS_ICON = 'icon-root-cause-risks';
export const ROOT_CAUSE_TYPE = '0';

export interface EntityData {
  [key: number]: RisksCategory;
}

export interface RisksCategory {
  items: Array<Risk>;
  total: number;
}

export interface Risk {
  name: string;
  nodeName: string;
  nodeId?: string;
  routineId?: number;
  specifics: RiskSpecifics;
}

export interface RiskSpecifics {
  existsInEra: boolean;
  nodeName?: string;
  ruleId?: string;
  ruleLink?: string;
  nodeLink?: string;
  type?: number;
}

export interface LastSearchValues {
  [TYPES_OF_RISKS.TYPE_ERA]: string;
  [TYPES_OF_RISKS.TYPE_CLOUD_SECURITY]: string;
}

export enum RiskIncidentSidePanelEvents {
  OPEN_CLOUD_SECURITY_LINK = 'openCloudSecurityLink',
  PIVOT_TO_VULNERABILITIES = 'pivotToVulnerabilities',
  PIVOT_TO_DEVICES = 'pivotToDevices',
  PIVOT_TO_DEVICES_CLOUD = 'pivotToDevicesCloud',
  PIVOT_TO_MISCONFIGURATION = 'pivotToMisconfiguration',
}

export interface MisconfigurationData {
  misconfigurationName: string;
  misconfigurationId: string;
}

export interface DeviceData {
  deviceName: string;
  deviceId: string;
  deviceType: number;
}

export interface VulnerabilityData {
  vulnerabilityName: string;
}
